export default __webpack_public_path__ + "static/media/notebook-tabs.fb251499.svg";